import { useRouter } from 'next/router'
import { usePrefs } from '@/lib/client/prefs'
import { canEdit, useSession } from '@/lib/client/session'

const isAdminPath = (pathname: string): boolean => pathname === '/admin' || pathname.startsWith('/admin/')

/**
 * Whether review states (समीक्षाधीन and the rest) may show here: only for editors, reviewers and admins, always
 * inside /admin, and on learner pages only after they switch on "Show review labels" (the `showReview` pref).
 * False on the server and until the session has loaded, so learners never get a flash of review labels.
 */
export const useReviewView = (): boolean => {
    const { user } = useSession()
    const { showReview } = usePrefs()
    const router = useRouter()

    if (!canEdit(user)) return false

    return isAdminPath(router.pathname) || showReview
}
